import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'bdb-watch-timer',
  templateUrl: './bdb-watch-timer.component.html',
  styleUrls: ['./bdb-watch-timer.component.scss']
})

/**
 * Implementacion del reloj para control de tiempo.
 * @author Iarteaga
 */
export class WatchTimerComponent implements OnInit {
  @Input() tiempo: number;
  @Output() endTime = new EventEmitter<boolean>();
  alertValue: string;

  ngOnInit() {
  }

  /*
   * Evento para notificar que se acabo el tiempo
   */
  onAlert(evento) {
      console.log('Valor:  ' + this.alertValue);
      this.endTime.emit( true );
  }


  /*
  funcionTimer: any;
  intervaloTiempo: number = 125; //Intervalo de tiempo de repeticion
  contadorTiempo: number = 0; //Indicador del tiempo que transcurre
  horas: number;      // Horas transcurridas
  minutos: number;    // Minutos transcurridos
  segundos: number;   // Segundos transcurridos
  */


  /*
   * Metodo que genera el formato del timer en HH:MM:SS
   */
  /*
  generarFormatoTiempo(tiempoSinFormato): string {
    this.horas = Number(tiempoSinFormato / 3600);
    this.minutos = Number((tiempoSinFormato - (this.horas*3600)) / 60);
    this.segundos = Number((tiempoSinFormato - (this.horas*3600) - (this.minutos*60)));
    var formato = ""+(this.horas==0?"":(this.horas<10?"0"+this.horas+":":this.horas+":"))+
       (this.minutos==0?"":(this.minutos<10?"0"+this.minutos+":":this.minutos+":"))+(this.segundos<10?"0"+this.segundos:this.segundos);
    return "" + formato;
  }
  */

  /*
   * Metodo que habilita la animacion del reloj
   */
  /*
  setTimeMotion() {
    funcionTimer = function() {
      var imagenTimer = document.getElementById('timer-imagen');
      var contador = document.getElementById('contador');
      var angulo = Number(0);
      var anguloIncremento = Number(0.5);
      imagenTimer.setAttribute("stroke-dasharray", angulo + ", 200000");
      contador.innerHTML = generarFormatoTiempo(Nummber(contadorTiempo++));
      var limite = Number( 359 + (359/2.5) );
      if (angulo >= limite) {
        window.clearInterval(funcionTimer);
      }
      angulo += anguloIncremento;
      console.log("->"+angulo);
    }
  }
  */

  /*
  circleAnimacion():void {
    var imagenTimer = document.getElementById('timer-imagen');
    var contador = document.getElementById('contador');
    //tiempo en milisegundos 1 seg = 1000
    var intervaloTiempo = Number(125);
    var angulo = Number(0);
    var anguloIncremento = Number(0.5);
    window.timer = window.setInterval(function () {
      imagenTimer.setAttribute("stroke-dasharray", angulo + ", 200000");
      contador.innerHTML = pintarTiempo(parseInt(contadorTiempo++));
      //= parseInt(contador.innerHTML) - 1; //parseInt(angle/360*100)) + '';
      var limite = Number( 359 + (359/2.5) );
      if (angulo >= limite) {
        window.clearInterval(window.timer);
      }
      angulo += anguloIncremento;
console.log("->"+angulo);
    }.bind(this), intervaloTiempo);
  }
  */
}



// WEBPACK FOOTER //
// ./src/app/bdb-watch-timer/bdb-watch-timer.component.ts